<template>
  <ElDialog name="contact-delete-modal"
    :visible="show"
    v-on="$listeners"
    v-loading="loading"
    :title="$t('contacts.deleteContact')"
    append-to-body
  >
    <div>
      <p>
        {{ $t('contacts.deleteContactWarning', { name: contact.title }) }}
      </p>
      <VForm :onSubmit="validateForm" data-vv-scope="contact-delete">
        <div slot="formButtons" type="left">
          <VButton
            type="outline-1"
            data-ec="delete_contact_modal"
            data-et="cancel_button"
            @click="$emit('close')"
            data-test="contacts-delete-cancel-button">
            <span>{{ $t('functional.cancel') }}</span>
          </VButton>
        </div>
        <div
          slot="formButtons"
          type="right"
          data-test="contacts-delete-confirm-button">
          <VButton
              type="error"
              subtype="submit"
              data-ec="delete_contact_modal"
              data-et="delete_contact_button">
            <TrashIcon />
            <span>{{ $t('contacts.deleteContact') }}</span>
          </VButton>
        </div>
      </VForm>
    </div>
  </ElDialog>
</template>
<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import { TrashIcon } from '@/components/icons/fontIcons';

export default {
  name: 'DeleteContactModal',
  props: {
    show: Boolean,
    contact: Object,
  },
  inject: {
    $validator: '$validator',
  },
  data() {
    return {
      loading: false,
    };
  },
  components: {
    VButton,
    VForm,
    TrashIcon,
  },
  methods: {
    validateForm(scope) {
      this.loading = true;
      this.$validator.validateAll(scope).then(() => this.$store.dispatch('contacts/DELETE', this.contact).then(() => {
        this.$emit('close');
      }).finally(() => {
        this.loading = false;
      }));
    },
  },
};
</script>
